export default __webpack_public_path__ + "static/media/logo-footer.ab1ae216.svg";